// extracted by mini-css-extract-plugin
export default {"root":"IconCategoryUrn_root__rE2nK"};